import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { CommonActions } from 'src/app/common/store/actions/common.actions';

import { selectAuthMessage, selectDealerData, selectLoggedInUserDataId} from 'src/app/common/store/state/app.state';
import { Dealer } from 'src/app/public/account/models/dealer.model';
import { ObjectSource } from 'src/app/public/common/constants/general-basic-data';

@Component({
    selector: 'app-dealer-appointments',
    templateUrl: './dealer-appointments.component.html',
    styleUrls: ['./dealer-appointments.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DealerAppointmentsComponent implements OnInit{

  myDealerData$: Observable<Dealer>;
  authFeedback$: Observable<string>;

  currentUserId$: Observable<string>;
  currentUserId: string = "";

  dealerData: Dealer = new Dealer();

  objectSource: ObjectSource = ObjectSource.DEALER

  constructor(
    private store: Store, 

    private route: ActivatedRoute) {

      this.currentUserId$ = this.store.select(selectLoggedInUserDataId);

      this.myDealerData$ = this.store.select(selectDealerData);
      this.authFeedback$ = store.select(selectAuthMessage);

      
    }
  
  ngOnInit(): void {

    this.currentUserId$.subscribe( (userId: string) => {
      this.currentUserId = userId;
      this.store.dispatch(CommonActions.fetchMyAppointmentsSubmit({dealerId: this.currentUserId }));
      
    }
    );

    this.myDealerData$.subscribe( (dealerData: Dealer) => {
      this.dealerData = dealerData;
      }
    );
  } 
}
